import React__default, { forwardRef } from 'react';
import { toSpacingAttributes } from './Spacing/spacing.js';
import './Section.scss';

const Section = forwardRef(({ children, className, id, variant = 'transparent', layout = variant === 'transparent' ? 'full-height' : 'padded', margin, padding, isScrollable, isPositionContainer, }, ref) => {
    return (
    // We're not using a native <section> element here because that element comes with
    // specific meanings that won't be true for all uses of this component.
    React__default.createElement("div", { ref: ref, className: className, id: id, "data-rev-component": 'section', "data-rev-variant": variant, "data-rev-layout": layout, "data-rev-scrollable": isScrollable, "data-rev-position-container": isPositionContainer, ...toSpacingAttributes('m', margin), ...toSpacingAttributes('p', padding) }, children));
});
Section.displayName = 'Section';

export { Section };
//# sourceMappingURL=Section.js.map
